export default "__VITE_ASSET__BC_oqswy__"